// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationsComponent {
    position: fixed;
    visibility: hidden;
    opacity: 0;
    -webkit-transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;
    -moz-transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;
    -ms-transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;
    -o-transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;
    transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;
    width: 438px;
    background: #FFFFFF;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    transform: scaleY(0);
    padding: 16px;
    z-index: 20000;

}

.NotificationsComponent .NotificationsComponent-list{
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.NotificationsComponent-visible{
    visibility: visible;
    opacity: 1;
    transform: scaleY(1);
}

.NotificationsItem {
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;
}

.NotificationsItem + .NotificationsItem {
    border-top: 1px solid #EEEEEE;
    padding-top: 16px;
}

.NotificationsItem > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.NotificationsItem-dot {
    display: inline-flex;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #DDDDDD;
    align-self: flex-start;
    margin-top: 10px;
}

.NotificationsItem-dot-pending {
    background-color: #F86567;
}

.NotificationsItem > .material-icons {
    color: #CCCCCC;
}

.NotificationsItem-text {
    margin: 0;
    padding: 0;
    font-size: 14px;
    line-height: 19px;
    color: #212121;
    flex: none;
    order: 0;
    flex-grow: 0;
}

.NotificationsItem-time {
    font-size: 10px;
    line-height: 12px;
    color: #AAAAAA;
    flex: none;
    order: 1;
    flex-grow: 0;
}

@media(max-width: 1024px){
    .NotificationsComponent {
        width: 100% !important;
        left: 0 !important;
        top: 66px !important;
    }
    #NavDrawer .ant-menu-item.menu-notification {
        display: none !important;
    }
}

.NotificationsComponent-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px 0;
}`, "",{"version":3,"sources":["webpack://./src/v3/components/Notifications/Notifications.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,wGAAwG;IACxG,qGAAqG;IACrG,oGAAoG;IACpG,mGAAmG;IACnG,gGAAgG;IAChG,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".NotificationsComponent {\n    position: fixed;\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;\n    -moz-transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;\n    -ms-transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;\n    -o-transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;\n    transition: opacity 200ms ease-in-out, transform 200ms ease-in-out, visibility 200ms ease-in-out;\n    width: 438px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);\n    border-radius: 8px;\n    transform: scaleY(0);\n    padding: 16px;\n    z-index: 20000;\n\n}\n\n.NotificationsComponent .NotificationsComponent-list{\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.NotificationsComponent-visible{\n    visibility: visible;\n    opacity: 1;\n    transform: scaleY(1);\n}\n\n.NotificationsItem {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    cursor: pointer;\n}\n\n.NotificationsItem + .NotificationsItem {\n    border-top: 1px solid #EEEEEE;\n    padding-top: 16px;\n}\n\n.NotificationsItem > div {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.NotificationsItem-dot {\n    display: inline-flex;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background-color: #DDDDDD;\n    align-self: flex-start;\n    margin-top: 10px;\n}\n\n.NotificationsItem-dot-pending {\n    background-color: #F86567;\n}\n\n.NotificationsItem > .material-icons {\n    color: #CCCCCC;\n}\n\n.NotificationsItem-text {\n    margin: 0;\n    padding: 0;\n    font-size: 14px;\n    line-height: 19px;\n    color: #212121;\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n}\n\n.NotificationsItem-time {\n    font-size: 10px;\n    line-height: 12px;\n    color: #AAAAAA;\n    flex: none;\n    order: 1;\n    flex-grow: 0;\n}\n\n@media(max-width: 1024px){\n    .NotificationsComponent {\n        width: 100% !important;\n        left: 0 !important;\n        top: 66px !important;\n    }\n    #NavDrawer .ant-menu-item.menu-notification {\n        display: none !important;\n    }\n}\n\n.NotificationsComponent-empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 20px 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
